import { getEndpoint } from "./schemaProvider"
import store from "@/store/store";

function getFilenameFromDisposition(contentDisposition) {
    if (!contentDisposition) return "export.xlsx"
    if (contentDisposition.indexOf("attachment") !== -1) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        const matches = filenameRegex.exec(contentDisposition)
        if (matches?.[1]) {
            return matches[1].replace(/['"]/g, "")
        }
    }
    return "export.xlsx"
}

function saveBlob(blob, contentDisposition) {
    const downloadUrl = window.URL.createObjectURL(blob)
    const filename = getFilenameFromDisposition(contentDisposition)
    const link = document.createElement("a")
    if (typeof link.download === "undefined") {
        window.location.href = downloadUrl
    } else {
        link.href = downloadUrl
        link.download = filename
        document.body.appendChild(link)
        link.click()
    }
}

export async function excelExport(entityKey, scope, model) {
    const endpointInfo = getEndpoint(entityKey, "export", scope)

    try {
        if (!endpointInfo) {
            throw new Error("No export endpoint found for this entity")
        }

        const response = await fetch(endpointInfo.path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: model ? JSON.stringify(model) : null
        })

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`)
        }

        const blob = await response.blob()
        saveBlob(blob, response.headers.get("content-disposition"))
    } catch (error) {
        store.dispatch("alert/error", "There was an error downloading the file. " + error);
    }
}

export default {
    excelExport
}
